module.exports = __webpack_public_path__ + "static/media/Multichain Maxi.ef33f573.png";